import { Children, cloneElement, PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ChildrenShape } from '../../utils/utils';

import { AccordionItem } from './AccordionItem/AccordionItem';

export class Accordion extends PureComponent {
  static Item = AccordionItem;

  constructor(props) {
    super(props);

    this.state = {
      items: Children.toArray(props.children),
      openItems: this.getInitOpenItems(props),
    };
  }

  // A check to see if dynamic data is added to
  // the accordion list and add it to the open accordion items.
  static getDerivedStateFromProps(props, state) {
    const { children } = props;
    const { openItems, items } = state;
    Children.map(Children.toArray(children), (child, idx) => {
      if (!items[idx] && child && child.props.initOpen) {
        openItems.push(`item-${idx}`);
      }
    });
    return {
      ...state,
      items: Children.toArray(children),
      openItems,
    };
  }

  getInitOpenItems(props) {
    const initOpenItems = [];

    Children.map(props.children, (child, idx) => {
      if (child && child.props.initOpen) {
        const id = `item-${idx}`;

        initOpenItems.push(id);
      }
    });

    return initOpenItems;
  }

  isOpen(id) {
    const { openItems } = this.state;
    return openItems.indexOf(id) > -1;
  }

  onClick(id) {
    let openItems = [];

    if (this.isOpen(id)) {
      openItems = this.props.isMultiOpen
        ? this.state.openItems.filter((itemId) => itemId !== id)
        : [];
    } else if (this.props.isMultiOpen) {
      openItems = this.state.openItems.slice(0);
      openItems.push(id);
    } else {
      openItems = [id];
    }

    this.setState({ openItems });
  }

  render() {
    const { hasFullWidthContent, noBorder } = this.props;

    return Children.map(this.props.children, (child, idx) => {
      if (child !== null) {
        const id = `item-${idx}`;
        const {
          props: { hasChild, children },
        } = child;

        if (hasChild) {
          const newChild = cloneElement(children, {
            id,
            hasFullWidthContent,
            noBorder,
            open: this.isOpen(id),
            onClick: (id) => this.onClick(id),
          });

          return cloneElement(child, {
            children: newChild,
          });
        }

        return cloneElement(child, {
          id,
          open: this.isOpen(id),
          hasFullWidthContent,
          noBorder,
          onClick: (id) => this.onClick(id),
        });
      }
    });
  }
}

Accordion.propTypes = {
  children: ChildrenShape,
  isMultiOpen: PropTypes.bool,
  hasFullWidthContent: PropTypes.bool,
  noBorder: PropTypes.bool,
};

Accordion.defaultProps = {
  children: null,
  isMultiOpen: false,
  hasFullWidthContent: false,
  noBorder: false,
};
